const PendoTags: { [key: string]: string } = {
  DISCOVER_MORE_LINK: 'discover-more-link',
  DISCOVER_TILE: 'discover-tile',
  CREATE_NEW: 'create_new',
  GO_TO_DISCOVER: 'go_to_discover',
  GO_TO_BOOMIVERSE: 'go_to_boomiverse',
  RECENTLY_USED: 'recently-used',
  INTEGRATION: 'Integration',
  MASTER_DATA_HUB: 'master_data_hub',
  API_MANAGEMENT: 'api_management',
  EVENT_STREAMS: 'event_streams',
  FLOW: 'Flow',
  DATA_CATALOG_PREPARATION: 'data_catalog_preparation',
  BOOMIVERSE_COMMUNITY: 'boomiverse_community',
  TRAINING_CERTIFICATION: 'training_certification',
  DOCUMENTATION: 'documentation',
  SUPPORT: 'Support',
  USAGE_BILLING: 'usage_billing',
  BOOMIVERSE_TRAINING_LINK: 'boomiverse_training_link',
  TRAINING_TILE: 'training_tile',
  // Boomi AI pendo tags
  AI_REUSABLE_COMPONENTS_EXISITNG_CONNECTION: 'ai_reusable_components_existing_connection',
  AI_REUSABLE_COMPONENTS_CREATE_PROCESS: 'ai_reusable_components_create_process',
  AI_REUSABLE_COMPONENTS_CREATE_PROCESS_OVER_LIMIT: 'ai_reusable_components_create_process_over_limit',
};

export default PendoTags;
